import React, { useEffect, createElement } from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { ServicesSection } from '../components/ServicesSection';
import { ProcessSection } from '../components/ProcessSection';
import { ArchitectureSection } from '../components/ArchitectureSection';
import { OutcomesSection } from '../components/OutcomesSection';
import { ExpertiseSection } from '../components/ExpertiseSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function HomePage() {
  useEffect(() => {
    // Set document metadata
    document.title = 'SCIENS Technologies — AI Services';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'SCIENS Technologies designs AI that learns, adapts, and delivers measurable impact—from Assistants and Copilots to Autopilots and Agents. See our approach, architecture, outcomes, accelerators, and industries.');
    }
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      metaThemeColor.setAttribute('content', '#2563eb');
    }
    // Load chatbot script
    const script = document.createElement('script');
    script.src = 'https://platform.easyparle.com/w/chat_plugin.js';
    script.setAttribute('data-bot-id', '4244');
    script.async = true;
    document.body.appendChild(script);
    return () => {
      // Cleanup script on unmount
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);
  return <div className="min-h-screen w-full bg-white" data-id="element-170">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:bg-white focus:text-blue-700 focus:px-3 focus:py-2 focus:rounded-md focus:ring focus:ring-blue-300 focus:z-50" data-id="element-171">
        Skip to content
      </a>
      <Header data-id="element-172" />
      <main id="main" data-id="element-173">
        <Hero data-id="element-174" />
        <ServicesSection data-id="element-175" />
        <ProcessSection data-id="element-176" />
        <ArchitectureSection data-id="element-177" />
        <OutcomesSection data-id="element-178" />
        <ExpertiseSection data-id="element-179" />
        <CTASection data-id="element-180" />
      </main>
      <Footer data-id="element-181" />
    </div>;
}